import { useMemo } from 'react'
import {
  PlanSettingsElement,
  isPlanSettingsElement,
} from '@editor/pages/StructuralPlanning/components/PlanSettingsForm/utils'
import { useSelectionStore } from '@editorStores'
import { useGuidToElementIncludingRips } from '@editorHooks'

/** The single selected element whose settings the plan view's "Bauteil" tab shows, if any. */
const usePlanViewSelectedElement = (): PlanSettingsElement | null => {
  const guid = useSelectionStore(state =>
    state.selection?.type === 'planar' && state.selection.guids.length === 1
      ? state.selection.guids[0]
      : null,
  )
  const guidToElement = useGuidToElementIncludingRips()

  return useMemo(() => {
    const element = guid ? guidToElement[guid] : undefined
    return element && isPlanSettingsElement(element) ? element : null
  }, [guid, guidToElement])
}

export default usePlanViewSelectedElement
